import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];

export const SchoolInformationRoutingProvider = RouterModule.forRoot(routes, { useHash: true });